import '../controllers/landing_pages/promo_list_two_cols/main.js'
